


































































































































































  import {Component} from 'vue-property-decorator';
import ItemModel from '@/models/ItemModel';
import Alert from '@/models/Alert';
import {AlertTypes} from '@/models/AlertTypes';
import {deleteUser, fetchUser, fetchUsers, saveUser} from "@/repositories/api/UserApi";

import BaseLayout from '@/layouts/BaseLayout.vue';
import Overlay from '@/models/Overlay';
import UserListView from "@/views/administration/UserListView.vue";
  import User from "@/models/User";
  import Breadcrumb from "@/models/Breadcrumb";

@Component({
    components: {
        BaseLayout,
    }
})
export default class UserSaveView extends UserListView {
  protected id = 0;
  protected title = 'Utilisateurs';
    protected breadcrumbs: Breadcrumb[] = [
        {
            text: 'Accueil',
            disabled: false,
            icon: '',
            href: '/',
        },
        {
            text: 'Administration',
            disabled: false,
            icon: '',
            href: '/administration/utilisateurs',
        },
        {
            text: 'Utilisateurs',
            disabled: false,
            icon: '',
            href: '/administration/utilisateurs',
        },
        {
            text: 'Liste',
            disabled: false,
            icon: '',
            href: '/administration/utilisateurs/liste',
        },
        {
            text: 'Modification',
            disabled: true,
            icon: '',
            href: '/administration/utilisateurs/liste',
        },
    ];
  protected fetchItems: Function = fetchUsers;
  protected newItemLabel = 'Nouvel utilisateur';
  protected headers = [
    {
      text: '#',
      align: 'left',
      sortable: true,
      value: 'id',
    },
    {text: 'Nom complet', value: 'fullName'},
    {text: 'Roles', value: 'roles'},
    {text: 'Email', value: 'email'},
    {text: 'Actions', value: 'action', sortable: false, align: 'right'},
  ];
  protected deleteDialog = false;
  protected loading = false;
  protected overlay = new Overlay();
  protected itemModels: ItemModel[] = [];
  protected itemDeleter: Function = deleteUser;
  protected deleteIndex: number = -1;
  protected alert: Alert = new Alert();
  protected selected: {id: number, name: string}[] = [];

  protected showPassword = false;

  newItemAction(){
      // @ts-ignore
      this.dialog = true;
  }

  updateFullName(){
      // @ts-ignore
      this.editedItem.fullName = `${this.editedItem.fistName || ''} ${this.editedItem.lastName || ''}`;
  }

  roleMappings = [
      {name: 'ROLE_USER', label: 'Utilisateur', textColor: 'white', color: 'grey'},
      {name: 'ROLE_ADMIN_FAUNA', label: 'Administrateur Faune', textColor: 'white', color: 'green'},
      {name: 'ROLE_ADMIN_FLORA', label: 'Administrateur Flore', textColor: 'white', color: 'green'},
      {name: 'ROLE_ADMIN', label: 'Administrateur', textColor: 'white', color: 'blue'},
      {name: 'ROLE_SUPER_ADMIN', label: 'Super Administrateur', textColor: 'white', color: 'indigo'},
      {name: 'ROLE_DEVELOPER', label: 'Développeur', textColor: 'white', color: 'deep-purple'},
  ];

    emailRules = [
        (value: string) => !!value || 'Un e-mail est requis',
        (value: string) => /.+@.+/.test(value) || 'L\'email doit être valide',
    ];

    passwordRules = [
        (value: string) => !!value || 'Mot de passe requis',
        (value: string) => value && value.length >= 8 || 'Le mot de passe doit contenir au moins de 8 caractères',
    ];

    async deleteItem(item: User) {
    let deleted = false;
    this.overlay.text = 'Suppression de l\'élément ' + item.fullName + ' en cours...';
    this.overlay.show = true;

    try {
      const response: { status: string, message: string } = await this.itemDeleter(item.id);

        this.alert = new Alert(response.message, response.status, true);

      if(response.status == 'success'){
          await this.$router.replace({name: 'user_list'});
      }
    } catch (e) {
      this.alert = new Alert(e.toString(), AlertTypes.Error, true);
    }

    this.overlay.show = false;
  }

  async save() {
        this.updateFullName();
      this.overlay.text = `Enregistrement de l'utilsateur en cours...`;
      this.overlay.show = true;
      try {
          // @ts-ignore
          const response = await saveUser(this.editedItem);

          this.alert.type = AlertTypes.Success
          this.alert.message = `Utilisateur ${this.id > 0 ? 'crée' : 'modifié'} avec succès`;
          // this.$router.replace({name: 'user_list'});
          this.editedItem = response.data
      } catch (e) {
          this.alert.message = `Utilisateur n'a pu être ${this.id > 0 ? ' crée ' : ' modifié '}`;
          this.alert.type = AlertTypes.Error

      }

      this.alert.show = true;
      this.overlay.show = false;
  }

  async processDeleteItem() {
  this.deleteDialog = false;
  if (await this.deleteItem(this.items[this.deleteIndex])) {
    this.items.splice(this.deleteIndex, 1);
  }
}

  async processSelectedDeleteItem() {
    this.selectedDeleteDialog = false;
    for (const item of this.selected) {
      if (await this.deleteItem(item)) {
        this.selected.splice(this.selected.indexOf(item), 1);
        this.items.splice(this.items.indexOf(item), 1);
      }
    }
  }

  async loadItem(id: number){
      this.overlay.text = `Chargement de l'utilsateur en cours...`;
      this.overlay.show = true;
      try {
          // @ts-ignore
          const response = await fetchUser(id);

          // @ts-ignore
          this.editedItem = response.data;
      } catch (e) {

      }

      this.overlay.show = false;
  }

  mounted() {
      if(this.$route.params.id){
          this.newItemLabel = 'Modifier';
          this.id = Number(this.$route.params.id);
          this.loadItem(this.id);
      } else {
          this.newItemLabel = 'Créer';
      }
  }
}
